module.exports = __webpack_public_path__ + "static/media/2H.1b2188a0.svg";